<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <h1 class="title">Get log in link</h1>

          <div v-if="isLoading" class="text-center">
            <hr class="space space-sm">
            <loader size="128px"></loader>
            <p class="small muted pt-4">Just a moment...</p>
          </div>
          <div v-else>
            <b-form @submit.prevent="submit">
              <b-form-group label="Email:">
                <b-form-input id="email"
                              type="email"
                              ref="email"
                              v-model="form.email"
                              required>
                </b-form-input>
              </b-form-group>
              <div class="error" v-if="hasError">
                Oops, that didn't work. Try again?
              </div>

              <div v-if="isDone">
                <p>All done. Check your inbox for a link to reset your password.</p>
              </div>
              <div v-else>
                <b-button type="submit" variant="primary">Get a Magic Link to Log in</b-button>
              </div>
            </b-form>
          </div>

          <hr class="space space-xs">

          <p v-if="!isDone">Enter your email to receive a one-time log in link and set a new password.</p>

          <hr class="space space-sm">
          <router-link :to="{ name: 'login' }">Back to Login</router-link>

        </div>
      </div>
    </div>
    <hr class="divider">
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: false,
      isDone: false,
      hasError: false,
      errorsInfo: null,
      form: {
        email: ''
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$refs.email.$el.focus()
  },
  methods: {
    submit () {
      this.$validator.validateAll().then(result => {
        this.isLoading = true
        this.hasError = false
        const { form } = this
        if (result) {
          this.$store.dispatch('PASSWORD_RESET', form).then((response) => {
            this.isLoading = false
            this.isDone = true
          }, error => {
            console.log('error', error)
            this.errorsInfo = error.response.data
            this.isLoading = false
            this.hasError = true
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
